"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.dateTimeFormat = exports.BaseApiClient = void 0;
const axios_1 = __importDefault(require("axios"));
//import { handleAxiosError } from '../errors';
class BaseApiClient {
    createAxiosClient;
    httpClient;
    token;
    constructor(host, timeout = 1000, token = '', createAxiosClient = axios_1.default.create) {
        this.createAxiosClient = createAxiosClient;
        this.httpClient = createAxiosClient({
            baseURL: host,
            timeout,
        });
        this.token = token;
    }
    async request(method, path, query, body) {
        const response = await this.httpClient.request({
            method,
            url: path,
            headers: this.headers(),
            data: body,
            params: this.query(query),
        });
        return response;
    }
    headers() {
        return {
            Accept: 'application/json',
            'Accept-Encoding': 'gzip,deflate,br',
            Authorization: 'Bearer ' + this.token,
        };
    }
    query(params) {
        if (!params) {
            return {};
        }
        const result = {};
        for (const [key, value] of Object.entries(params)) {
            if (value !== null && value !== undefined) {
                if (value instanceof Date) {
                    const formattedValue = dateTimeFormat(value);
                    if (formattedValue !== null) {
                        result[key] = formattedValue;
                    }
                }
                else {
                    result[key] = value.toString();
                }
            }
        }
        return result;
    }
}
exports.BaseApiClient = BaseApiClient;
function dateTimeFormat(date) {
    if (!date) {
        return null;
    }
    const milliseconds = date.getTime();
    if (Number.isNaN(milliseconds)) {
        return null;
    }
    return milliseconds.toString();
}
exports.dateTimeFormat = dateTimeFormat;
